/*
 * Purpose: Mission vs Flow badge — running Mission pulsing, validated Flow solid
 * Last modified: 2026-06-27 | Agent
 * Completeness: 100
 */
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { CheckCircle2, Zap } from 'lucide-react';
import type { ArtifactState } from '@/services/autoblocks/missionTypes';
import type { ComposeMode } from '@/services/autoblocks/missionTypes';
import { composeModeLabel } from '@/services/autoblocks/flowMode';
import { PRODUCT_TERMS } from '@/lib/productTerms';

interface ArtifactStateBadgeProps {
  artifactState: ArtifactState;
  composeMode?: ComposeMode | null;
  className?: string;
}

export function ArtifactStateBadge({
  artifactState,
  composeMode,
  className,
}: ArtifactStateBadgeProps) {
  const isMission = artifactState === 'mission';

  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)}>
      <Badge
        variant={isMission ? 'default' : 'secondary'}
        className={cn(
          'gap-1.5 text-xs font-semibold',
          isMission && 'animate-pulse bg-primary/90'
        )}
      >
        {isMission ? (
          <Zap className="h-3 w-3" aria-hidden />
        ) : (
          <CheckCircle2 className="h-3 w-3 text-ab-green-deep dark:text-ab-green-glow" aria-hidden />
        )}
        {isMission ? 'Mission' : PRODUCT_TERMS.autoBlockFlow}
      </Badge>
      {isMission && composeMode && (
        <Badge variant="outline" className="text-[10px]">
          {composeModeLabel(composeMode)}
        </Badge>
      )}
    </div>
  );
}
